import Vue from "vue";
import VueRouter from "vue-router";

import Home from "@/pages/HomePage.vue";
import About from "@/pages/AboutPage.vue";

import DashboardLayout from "@/layouts/DashboardLayout.vue";
import FeatLayout from "@/layouts/FeatureLayout.vue";
import Dashboard from "@/pages/DashboardPage.vue";
import BlankLayout from "@/layouts/BlankLayout.vue";
import SettingsLayout from "@/layouts/SettingsLayout.vue";
import AttendancePageVue from "@/pages/attendance/AttendancePage.vue";
import NewAttendancePageVue from "@/pages/attendance/NewAttendancePage.vue";
import OvertimePageVue from "@/pages/reports/Overtime/OvertimePage.vue";
import NewOvertimePageVue from "@/pages/reports/Overtime/NewOvertimePage.vue";
import ReportPageVue from "@/pages/reports/ReportPage.vue";
import DailyReportPageVue from "@/pages/reports/Daily/DailyReportPage.vue";
import PatrolReportPageVue from "@/pages/reports/Patrol/PatrolReportPage.vue";
import CleaningReportPageVue from "@/pages/reports/Cleaning/CleaningReportPage.vue";
import NewPatrolReportPageVue from "@/pages/reports/Patrol/NewPatrolReportPage.vue";
import NewDailyReportPageVue from "@/pages/reports/Daily/NewDailyReportPage.vue";
import NewCleaningReportPageVue from "@/pages/reports/Cleaning/NewCleaningReportPage.vue";
import NewInventoryReportPage from "@/pages/reports/Cleaning/NewInventoryReportPage.vue";
import PayrollPageVue from "@/pages/payroll/PayrollPage.vue";
import DevPageVue from "@/pages/DevPage.vue";
import SettingsPage from "@/pages/SettingsPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },

  {
    path: "/",
    component: SettingsLayout,
    children: [

      {
        path: "/dashboard",
        component: DashboardLayout,
        children: [
          {
            path: "",
            component: Dashboard
          },
          {
            path: "about",
            component: About
          }
        ]
      },

      {
        path: "/settings",
        component: SettingsPage,
      }

    ]
  },

  {
    path: "/dashboard",
    component: BlankLayout,
    children: [
      {
        path: "attendance",
        component: FeatLayout,
        props: {
          title: "Attendance"
        },
        children: [
          {
            path: "",
            component: AttendancePageVue
          },
          {
            path: "monitor",
            component: () => import("@/pages/attendance/AttendanceMonitorPage.vue")
          },
          {
            path: "new",
            component: NewAttendancePageVue
          },
          {
            path: "new/in",
            props: { isIn: true },
            component: NewAttendancePageVue
          },
          {
            path: "new/out",
            props: { isIn: false },
            component: NewAttendancePageVue
          }
        ]
      },
      {
        path: "legal",
        component: FeatLayout,
        props: {
          title: "Legality"
        },
        children: [
          {
            path: "",
            component: () => import("@/pages/Legal/LegalMainPage.vue")
          }
        ]
      },
      {
        path: "dev",
        component: FeatLayout,
        props: {
          title: "Developer Test"
        },
        children: [
          {
            path: "",
            component: DevPageVue
          }
        ]
      },
      {
        path: "overtime",
        component: FeatLayout,
        props: {
          title: "Report"
        },
        children: [
          {
            path: "",
            component: OvertimePageVue
          },
          {
            path: "new",
            component: NewOvertimePageVue
          }
        ]
      },
      {
        path: "report",
        component: FeatLayout,
        props: {
          title: "Report"
        },
        children: [
          {
            path: "",
            component: ReportPageVue
          },
          {
            path: "daily",
            component: DailyReportPageVue
          },
          {
            path: "cleaning",
            component: CleaningReportPageVue
          },
          {
            path: "daily/new",
            component: NewDailyReportPageVue
          },
          {
            path: "cleaning/new",
            component: NewCleaningReportPageVue
          },
          {
            path: "inventory/new",
            component: NewInventoryReportPage
          }
        ]
      },
      {
        path: "report",
        component: FeatLayout,
        props: {
          title: "Patrol"
        },
        children: [
          {
            path: "patrol",
            component: PatrolReportPageVue
          },
          {
            path: "patrol/new",
            component: NewPatrolReportPageVue
          }
        ]
      },
      {
        path: "payroll",
        component: FeatLayout,
        props: {
          title: "Payroll"
        },
        children: [
          {
            path: "",
            component: PayrollPageVue
          }
        ]
      },
      {
        path: "manager",
        component: FeatLayout,
        props: {
          title: "Manager"
        },
        children: [
          {
            props: { title: "Live Track" },
            path: "tracking",
            component: () => import("@/pages/Manager/LiveTrackingPage.vue")
          },
          {
            props: { title: "History Timeline" },
            path: "timeline",
            component: () => import("@/pages/Manager/HistoryTrackingPage.vue")
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  window.document.title = (process.env.VUE_APP_TITLE || "TIME") + " ESS - Mobile";
  next();
});

export default router;
